import React, { FC } from 'react';

import Svg from './Svg';
import colors from '../../utils/colorConstants';

interface Props {
  width: string;
  height: string;
  stroke?: string;
  className?: string;
}

const Close: FC<Props> = ({ className, height, width, stroke = colors.lapel }) => {
  return (
    <Svg className={className} height={height} title="Close icon" viewBox="0 0 24 24" width={width}>
      <path
        d="M4 20L20 4M4 4l16 16"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </Svg>
  );
};

export default React.memo(Close);
